export default {
  title: 'Évaluation transfrontalière',
  noLongerRequired:
    'La pré-approbation n’est plus requise pour les évaluations transfrontalières.',
  noLongerRequiredDescription:
    'L’évaluation est désormais examinée par Vamoz et validée par les RH. Aucune action n’est requise de votre part et vous pouvez fermer cette fenêtre.'
};
